import styled from 'styled-components';

export const AppWrapper = styled.div`
  text-align: center;
  height: 100vh;
  width: 100vw;
  position: relative;
`;




// WEBPACK FOOTER //
// ./src/components/App/App.style.js